const storeName = 'Nonet'
const Storecolors = ['#FFFFFF','#1d6b92']
// NAVBAR COLOR ,
const logo = ''

export {storeName,Storecolors,logo}